import type { ExplainerIntensityKey, ExplainerResponse, ExplainerType } from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type {
  ExplainerCTA,
  ExplainerIntensity,
  ExplainerIntensityKey,
  ExplainerResponse,
  ExplainerType,
  ExplainerUpay,
} from "@ishvaram/api-client";

/**
 * GET /v1/explain/{type}/{id} — fetches the cultural prose + upays + CTA
 * shown in the <Explainable> sheet. If `intensity` is supplied, the
 * response narrows to that bucket; otherwise all three are returned.
 */
export function getExplainer(
  type_: ExplainerType,
  id: string,
  intensity?: ExplainerIntensityKey
): Promise<ExplainerResponse> {
  const params = new URLSearchParams();
  if (intensity) params.set("intensity", intensity);
  const qs = params.toString();
  return apiRequest<ExplainerResponse>(
    `/explain/${type_}/${encodeURIComponent(id)}${qs ? `?${qs}` : ""}`
  );
}
